import { Dialog } from "primereact/dialog";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { JVChips } from "../../shared/JVChips";
import { JVCheckbox } from "../../shared/JVCheckbox";

interface IMailContent {
    PO_ID?: number,
    Dates?: IPendingTimesheetDates[],
    EmailCC?: string,
    Subject?: string,
    EmailBody?: string,
}

interface IPendingTimesheetDates {
    From?: Date
    To?: Date
}

const schema = yup.object({
    //emailTo: yup.array().of(yup.string().email("Invalid Email ID")).min(1, "This field is required"),
    emailCC: yup.array().of(yup.string().email("Invalid Email ID").nullable()).nullable().min(1, "This field is required"),
    subject: yup.string().required("Email Subject is required"),
    to_Self: yup.boolean().nullable(),
    to_Subvendor: yup.boolean().nullable(),
    to_Accounts: yup.boolean().nullable(),
});

interface IProps {
    open: boolean,
    multiData: any,
    hideDialog: () => void,
    toast: any
}

interface IMail {
    //emailTo: string[],
    emailCC: string,
    subject: string,
    emailBody: string,
    to_Self: boolean,
    to_Subvendor: boolean,
    to_Accounts: boolean,
}

const bodyContent =
    `<p>Dear @Consultant_Name,</p></br>

<p>I hope you are doing well.</p></br>

<p>As per our records, your timesheets for the following dates are still pending:</p></br>
@FromToDates

<p>Please log in to the consultant portal and upload the missing timesheets for the above period at your earliest convenience.</p></br>

<p>Portal Link: <a href="https://resource.jobvritta.com/login" target="_blank">resource.jobvritta.com</a></p></br>

<p>Kindly ensure that all pending timesheets are updated and submitted. Going forward, please make sure to upload your timesheets on or before the due date each week to avoid any delays in processing and approvals.</p></br>

<p>Thank you for your prompt attention and cooperation.</p></br>

<p>Best regards,</p></br>
@Signature`;

export const SendEmail = ({ open, hideDialog, toast, multiData }: IProps) => {
    const [loading, setLoading] = useState(false);
    const [body, setBody] = useState(bodyContent);

    const { control, handleSubmit, formState: { errors }, reset, setValue } = useForm<IMail>({
        resolver: yupResolver(schema),
        defaultValues: {
            //emailTo: [],
            emailCC: '',
            subject: 'Action Required: Upload Pending Timesheets',
            emailBody: ''
        },
        shouldFocusError: false
    });

    const sendMail = async (fbody: IMail) => {


        const contentBody: IMailContent[] = multiData.map((el: any) => {

            let dates: IPendingTimesheetDates[] = [];

            if (el.isWeek1 === true) {
                dates.push({
                    From: new Date(el.week1From),
                    To: new Date(el.week1To)
                });
            }
            if (el.isWeek2 === true) {
                dates.push({
                    From: new Date(el.week2From),
                    To: new Date(el.week2To)
                });
            }
            if (el.isWeek3 === true) {
                dates.push({
                    From: new Date(el.week2From),
                    To: new Date(el.week2To)
                });
            }
            if (el.isWeek4 === true) {
                dates.push({
                    From: new Date(el.week2From),
                    To: new Date(el.week2To)
                });
            }
            if (el.isWeek5 === true) {
                dates.push({
                    From: new Date(el.week5From),
                    To: new Date(el.week5To)
                });
            }

            return {
                PO_ID: el.pO_Id,
                Dates: dates,
                EmailCC: (fbody.emailCC || "").replace(/\s+/g, '').split(","),
                Subject: fbody.subject,
                EmailBody: body
            }
        });
        setLoading(true);
        console.log(contentBody);
        const response = await Fetch("Timesheet/sendEmailForPendingTimesheets", "POST", contentBody, `toSelf=${fbody.to_Self === true ? 1 : 0}&toSub=${fbody.to_Subvendor === true ? 1 : 0}&toAccounts=${fbody.to_Accounts === true ? 1 : 0}`, toast);
        if (response) {
            onHide();
            toast.current.show({ severity: 'success', detail: "Mail Distributed Successfully.", life: 3000 });
        }
        setLoading(false);
    }

    function onSubmit(data: IMail) {
        if (body.length < 1) toast.current.show({ severity: 'error', detail: "Mail Body is Required.", life: 3000 });
        else sendMail(data);
    }

    const onHide = () => {
        hideDialog(); reset(); setBody("");
    }

    const header = () => {
        return <span>Send Pending Timesheet Email To Consultant's</span>
    }

    useEffect(() => {
        if (open) {
            setBody(bodyContent);
            reset({
                emailCC: '',
                subject: 'Action Required: Upload Pending Timesheets',
                emailBody: bodyContent
            });
        }
    }, [open]);

    return (
        <Dialog visible={open} style={{ width: '80vw' }} header={header} className="p-fluid" onHide={onHide} draggable={false}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <div className="field col-12 md:col-12 p-fluid formgrid grid ml-3" style={{border: "1px solid #ced4da", borderRadius: "5px", width: "90%"}}>
                    <JVCheckbox column={3} label="To Self" control={control} name="to_Self" />
                    <JVCheckbox column={3} label="To Subvendor" control={control} name="to_Subvendor" />
                    <JVCheckbox column={3} label="To US Accounts Team" control={control} name="to_Accounts" />
                </div>
                {/* <JVChips column={2} label="To" control={control} name="emailTo" error={errors.emailTo?.message ? errors.emailTo?.message : errors.emailTo && errors.emailTo[0]?.message} separator="," /> */}
                <JVChips column={2} label="CC (just Copy and paste emails)" control={control} name="emailCC" error={errors.emailCC && errors.emailCC?.message} separator="," />
                <JVInput column={1} required label="Subject" control={control} name="subject" error={errors.subject?.message} />
                <div className="col-12 md:col-12 md:col-6 mb-3">
                    <label>Body<span style={{ color: 'red' }}>* (Do change words starting with @)</span></label>
                    <CKEditor editor={ClassicEditor} data={body} onChange={(event, editor) => { setBody(editor.getData()); }} />
                </div>
                <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                    <Button className="field col-12 md:col-6  h-2rem" label="SEND" type="submit" loading={loading}></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined  h-2rem" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}